import React, {
  createContext, useCallback, useContext, useMemo, useState,
} from 'react';

interface SidePanelContext {
  isOpen: boolean;
  toggleIsOpen: VoidFunction;
  close: VoidFunction;
}

const SidePanelContext = createContext<Partial<SidePanelContext>>({});

interface SidePanelProviderProps {
  children: React.ReactNode;
  /** Начальное состояние панели; по умолчанию закрыта. */
  defaultOpen?: boolean;
}
function SidePanelProvider({
  children,
  defaultOpen = false,
}: SidePanelProviderProps): JSX.Element {
  const [isOpen, setIsOpen] = useState<boolean>(defaultOpen);
  const toggleIsOpen = useCallback(() => setIsOpen((prev) => !prev), []);
  const close = useCallback(() => setIsOpen(false), []);
  const contextValue = useMemo(() => ({
    isOpen,
    toggleIsOpen,
    close,
  }), [close, isOpen, toggleIsOpen]);

  return (
    <SidePanelContext.Provider value={contextValue}>
      {children}
    </SidePanelContext.Provider>
  );
}

const useSidePanel = (): SidePanelContext => useContext<SidePanelContext>(
  SidePanelContext as React.Context<SidePanelContext>,
);

export { SidePanelProvider, useSidePanel };
